<template>
  <div class="vv-card-container">
    <div class="virtual-visit-header-container">
      <div class="col">
        <div class="bc-header">Virtual Visits</div>
        <div class="bc-sub-header">
          Record a video walkthrough of a customer’s account to review what’s
          working & what’s not.
        </div>
      </div>
      <div
        v-if="adminRole !== 'viewer' && providerPlan?.planType === 'Hardware'"
        class="vv-button-container"
      >
        <button type="button" @click="launchVirtualVisit">
          <div class="virtual-visit-record-btn">
            <img
              src="@shared/assets/img/general/record-video-icon.svg"
              class="record-camera-icon"
              alt="Virtual Visit"
            />
            <div class="record-btn-txt">Record a New Virtual Visit</div>
          </div>
        </button>
      </div>
    </div>
    <div class="vv-row-container">
      <div
        v-for="(vv, idx) in vvs"
        :key="idx"
        class="vv-column-container"
        @click="editVirtualVisit(vv)"
        @keydown="editVirtualVisit(vv)"
      >
        <img
          :src="vv.thumbnailUrl"
          class="virtual-visit-thumbnail"
          alt="Virtual Visit"
        />
        <div class="vv-header">Virtual Visit</div>
        <div class="virtual-visit-upload-date">
          {{ formatDate(vv.recordedDate) }}
        </div>
        <div v-if="vv.sentDate" class="vv-sent-date">
          Sent {{ formattedDate(vv.sentDate) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import apiClient from '@shared/lib/general/apiClient';

export default {
  name: 'VirtualVisits',
  mixins: [customerDetailMixin],
  data() {
    return {
      show: true,
    };
  },
  computed: {
    vvs() {
      return this.virtualVisits;
    },
  },
  methods: {
    launchVirtualVisit() {
      this.toggleActionModal(true, 'launch-visit');
    },
    formatDate(recordedDate) {
      return moment(recordedDate).format('LL');
    },
    async editVirtualVisit(vv) {
      this.$store.dispatch('changeCustomerDetailValues', [
        {
          field: 'selectedVirtualVisit',
          value: vv,
        },
      ]);
      let tech = null;
      let avatarUri = null;
      if (this.customer.technicianId) {
        tech = await this.getTech();
        avatarUri = await this.getAvatarImg(tech.profileUrl);
      }
      this.toggleActionModal(true, 'edit-visit', tech, avatarUri);
    },
    async getTech() {
      const { data } = await apiClient({
        method: 'GET',
        url: `/technicians/id/${this.customer.technicianId}`,
      });
      return data;
    },
    async getAvatarImg(url) {
      try {
        const { data } = await apiClient({
          method: 'PUT',
          url: '/devices/ac/image/response',
          data: {
            url,
          },
        });
        return data;
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss">
.vv-card-container {
  background-color: $WHITE;
  margin-top: 24px;
  position: relative;
  border-radius: 8px;

  .bc-header {
    font-size: 1.125rem;
    color: $WHITE;
    font-weight: 500;

    @media (max-width: 1440px) {
      font-size: 1rem;
    }
  }
  .bc-sub-header {
    font-size: 1rem;
    color: $WHITE;
    font-weight: 400;

    @media (max-width: 1440px) {
      font-size: 0.75rem;
    }
  }

  .virtual-visit-header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    padding: 40px 16px;
    height: 56px;
    z-index: 2;
    top: 0;
    background-color: $CONTENTGRAY;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    .vv-button-container {
      display: flex;
    }

    .virtual-visit-record-btn {
      display: flex;
      flex-direction: row;
      background-color: $PRIMARY;
      width: 303px;
      padding: 10px;
      align-items: center;
      border-radius: 4px;
    }

    .record-camera-icon {
      height: 18px;
      width: 32px;
      margin-right: 5px;
    }

    .record-btn-txt {
      color: $WHITE;
      font-size: 18px;
      font-weight: 400;
    }
  }

  .vv-row-container {
    display: flex;
    justify-content: flex-start;
    padding: 16px 24px;
    overflow-x: auto;

    .vv-column-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      min-width: 250px;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }

      &:not(:first-child) {
        margin-left: 24px;
      }

      .vv-header {
        color: $SITH_GRAY;
        font-weight: 600;
      }

      .virtual-visit-thumbnail {
        width: 224px;
        height: 126px;
        margin-bottom: 10px;
      }

      .virtual-visit-upload-date {
        font-weight: 600;
        font-size: 24px;
        color: $PRIMARY;
        text-decoration: underline;
      }

      .vv-sent-date {
        margin-top: 6px;
        color: $SITH_GRAY;
        font-size: 0.8125rem;
        font-weight: 500;
      }
    }
  }
}
</style>
